import { status, StatusType } from '../typeStatus'

export const GET_RESUMEN = 'SET_RESUMEN'
export const GET_RESUMEN_SUCCESS = 'GET_RESUMEN_SUCCESS'
export const GET_RESUMEN_ERROR = 'GET_RESUMEN_ERROR'

export const InitialState: ResumenCuentaState = {
  resumen: null,
  resumenStatus: status.initial,
}

export interface ResumenCuentaState {
  resumen: Resumen | null
  resumenStatus: StatusType
}

export interface Resumen {
  generadoPor: string
  tipoDoc: string
  nroDocumento: string
  fecha: string
  vencimiento: string
  estado: string
  monto: string
  moneda: string
  documento: string
  nroCliente: string
}

export interface GetResumen {
  type: typeof GET_RESUMEN
  payload: null
}
export interface GetResumenSuccess {
  type: typeof GET_RESUMEN_SUCCESS
  payload: Resumen
}
export interface GetResumenError {
  type: typeof GET_RESUMEN_ERROR
  payload: boolean
}

export type ResumenCuentaActions = GetResumen | GetResumenSuccess | GetResumenError
